import React from 'react';
import { observer } from 'mobx-react';
import Typography from '@material-ui/core/Typography';
import { useAppStore } from '../../stores/AppStore';

const PageTitle: React.FC = () => {
  const appStore = useAppStore();
  return (
    <Typography component="h1" variant="h6" noWrap data-auto-id="top-title">
      {appStore.title}
    </Typography>
  );
};

export const PageTitleContainer = observer(PageTitle);
